// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/game_end/rewards_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/leaderboard/recap_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/HUD/button_bg_idle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/HUD/button_bg_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@assets/HUD/skip_btn_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@assets/game_end/leave_btn_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.endgame_buttons {
    position: absolute;
    bottom: clamp(24px, 5vh, 36px);
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    width: min(280px, 90vw);
}

.endgame_button {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-family: 'Kim';
    text-transform: uppercase;
    transition: all 0.2s ease;
    position: relative;
    border-radius: 4px;
}

.endgame_button_primary {
    height: clamp(44px, 8vh, 56px);
    font-size: clamp(16px, 3vw, 20px);
    background: linear-gradient(180deg, #ffd700 0%, #ffa600 100%);
    color: #1c1f25;
    border: 2px solid #ffd700;
    box-shadow: 
        0 0 20px rgba(255, 166, 0, 0.3),
        inset 0 0 10px rgba(255, 255, 255, 0.5);
    text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);
}

.endgame_button_primary:hover {
    transform: translateY(-2px);
    box-shadow: 
        0 0 30px rgba(255, 166, 0, 0.5),
        inset 0 0 15px rgba(255, 255, 255, 0.7);
}

.endgame_button_primary:active {
    transform: translateY(1px);
    background: linear-gradient(180deg, #ffa600 0%, #ffd700 100%);
}

.endgame_button_secondary {
    height: clamp(36px, 7vh, 48px);
    width: 90%;
    font-size: clamp(14px, 2.5vw, 16px);
    background: linear-gradient(to bottom, #2a3746 0%, #1c1f25 100%);
    color: #ffffff;
    border: 1px solid #3c616c;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.endgame_button_secondary:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 3px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
    opacity: 0;
    transition: opacity 0.2s ease;
}

.endgame_button_secondary:hover {
    border-color: #51fdff;
    box-shadow: 0 0 10px rgba(81, 253, 255, 0.3);
}

.endgame_button_secondary:active {
    transform: scale(0.98);
    background: linear-gradient(to bottom, #1c1f25 0%, #2a3746 100%);
}

.defeat_title {
    background-size: 100% 100%;
    height: clamp(24px, 5vh, 54px);
    width: min(800px, 90%);
    margin: clamp(16px, 5vh, 50px) auto clamp(12px, 3vh, 30px);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.defeat_title .defeat_title_bg {
    height: clamp(48px, 8vh, 96px);
    width: auto;
    max-width: 100%;
    object-fit: contain;
    animation: titleBounce 1s cubic-bezier(0.36, 0, 0.66, 1.5) forwards;
    transform-origin: center;
}

.defeat_title .defeat_title_effect {
    position: absolute;
    top: clamp(-32px, -6vh, -72px);
    right: 1vw;
    width: 30vh;
    animation: bounce 0.8s ease alternate;
    -webkit-animation: bounce 0.8s ease alternate;
    transform-origin: center;
}

@media screen and (max-width: 480px) {
    .defeat_title {
        width: 95%;
        height: clamp(20px, 4vh, 24px);
        margin: clamp(12px, 3vh, 16px) auto clamp(8px, 2vh, 12px);
    }
    
    .defeat_title .defeat_title_bg {
        height: clamp(36px, 6vh, 48px);
    }
    
    .defeat_title .defeat_title_effect {
        width: 50vh;
        top: clamp(-24px, -4vh, -28px);
    }

    @keyframes bounce {
        50% {
            transform: scale(1.15);
        }
    }

    @-webkit-keyframes bounce {
        50% {
            transform: scale(1.15);
        }
    }
}

@keyframes titleBounce {
    0% { 
        transform: scale(0.5); 
        opacity: 0;
    }
    50% { 
        transform: scale(1.2);
        opacity: 1;
    }
    75% { 
        transform: scale(0.9);
    }
    100% { 
        transform: scale(1);
    }
}

.endgame_rewards_container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    background-position: -18px;
    width: 100%;
    height: 156px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 30vh;
    z-index: 0;
}

/* Update media query for small screens */
@media screen and (max-width: 480px), 
       screen and (max-height: 600px) {
    .endgame_rewards_container {
        transform: scale(0.8);
        bottom: 25vh;
    }
    
    .endgame_rewards_items {
        gap: 8px;
        max-width: 90%;
    }
    
    .streak_gold_list {
        width: 56px;
        height: 56px;
    }
    
    .streak_gold_list > div:first-child {
        width: 36px;
        height: 36px;
    }
    
    .streak_gold_list_amount {
        font-size: 12px;
    }
}

.endgame_rewards_items {
    position: absolute;
    bottom: 18px;
    display: flex;
    gap: 12px;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    max-width: 80%;
    padding: 0 20px;
}

.streak_gold_list {
    width: 68px;
    height: 68px;
    background-color: #1c1f25;
    border: 1px solid #147fa6;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 10;
    position: relative;
    transition: transform 0.2s ease;
}

.streak_gold_list:hover {
    transform: scale(1.05);
    border-color: #51fdff;
    box-shadow: 0 0 10px rgba(81, 253, 255, 0.3);
}

.streak_gold_list > div:first-child {
    width: 42px;
    height: 42px;
    background-repeat: no-repeat;
}

.streak_gold_list img {
    width: 64px;
    height: 58px;
    margin-left: 6px;
}

.streak_gold_list_amount {
    position: absolute;
    bottom: 6px;
    right: 8px;
    font-size: 14px;
    font-weight: bold;
    color: white;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.endgame_rewards_heading_container {
    position: absolute;
    top: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.endgame_rewards_heading {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    text-transform: uppercase;
}

.victory_title_effect {
    position: absolute;
    top: -46px;
    left: calc(50% + 234px);
    font-size: 172px;
    font-weight: bolder;
    color: #ffffff;
    text-shadow: #afafaf 0px 4px;
  }

  .game_leave_dialog {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 100% 100%;
    width: 350px;
    height: 140px;
    padding: 15px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    color: #ffffff;
  }
  
  .game_leave_btn {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 100% 100%;
    width: 50%;
    height: 52px;
  
    display: flex;
    align-items: center;
    justify-content: center;
  
    color: #ffffff;
  }
  
  .game_leave_btn:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }

.endgame_meet_team_msg {
    font-size: 32px;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
}

.endgame_leave {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 100% 100%;
    width: 156px;
    height: 56px;
  
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
  
    display: flex;
    justify-content: center;
    align-items: center;
  
    padding-right: 8px;
    cursor: pointer;
  
    position: absolute;
    bottom: 36px;
}
  
.endgame_leave:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

/* For very small screens */
@media screen and (max-width: 360px) {
    .endgame_buttons {
        bottom: 16px;
        gap: 6px;
    }

    .endgame_button_primary {
        height: 40px;
    }

    .endgame_button_secondary {
        height: 32px;
    }
}

/* For landscape orientation */
@media screen and (max-height: 600px) and (orientation: landscape) {
    .endgame_buttons {
        bottom: 16px;
        gap: 8px;
    }

    .endgame_button_primary {
        height: 44px;
        font-size: 16px;
    }

    .endgame_button_secondary {
        height: 36px;
        font-size: 14px;
    }
}

.endgame_unlock_message {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(255, 255, 255, 0.1);
    padding: 12px 24px;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
}

.shaking-lock {
    width: 24px;
    height: 24px;
    animation: shake 2.5s ease-in-out infinite;
}

@keyframes shake {
    0%, 100% { transform: rotate(0deg); }
    20% { transform: rotate(-10deg); }
    40% { transform: rotate(10deg); }
    60% { transform: rotate(-10deg); }
    80% { transform: rotate(10deg); }
}

.endgame_characters_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
    justify-content: center;
    align-items: center;
    margin-top: 3vh;
    min-height: 20vh;
    padding: 0 20px;
}

@media (max-width: 768px) {
    .endgame_characters_grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
    }
}

@media (max-width: 480px) {
    .endgame_characters_grid {
        grid-template-columns: repeat(1, 1fr);
        gap: 10px;
    }
}

@media (max-height: 600px) {
    .endgame_characters_grid {
        margin-top: -1vh;
        transform: scale(0.8);
    }
}
  `, "",{"version":3,"sources":["webpack://./src/components/HUD/Endgame.style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;IACjC,6DAA6D;IAC7D,cAAc;IACd,yBAAyB;IACzB;;+CAE2C;IAC3C,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B;;+CAE2C;AAC/C;;AAEA;IACI,0BAA0B;IAC1B,6DAA6D;AACjE;;AAEA;IACI,8BAA8B;IAC9B,UAAU;IACV,mCAAmC;IACnC,gEAAgE;IAChE,cAAc;IACd,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,qFAAqF;IACrF,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;IACtB,gEAAgE;AACpE;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,sBAAsB;IACtB,0DAA0D;IAC1D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,mEAAmE;IACnE,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,UAAU;IACV,WAAW;IACX,qCAAqC;IACrC,6CAA6C;IAC7C,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;QACV,8BAA8B;QAC9B,yDAAyD;IAC7D;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI;YACI,sBAAsB;QAC1B;IACJ;;IAEA;QACI;YACI,sBAAsB;QAC1B;IACJ;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,qBAAqB;IACzB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,yDAAwD;IACxD,0BAA0B;IAC1B,0BAA0B;IAC1B,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA,yCAAyC;AACzC;;IAEI;QACI,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,yDAAyD;IACzD,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,yDAAuD;IACvD,0BAA0B;IAC1B,UAAU;IACV,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,cAAc;EAChB;;EAEA;IACE,yDAAyD;EAC3D;;AAEF;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yDAAoD;IACpD,0BAA0B;IAC1B,YAAY;IACZ,YAAY;;IAEZ,eAAe;IACf,gBAAgB;IAChB,cAAc;;IAEd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;IAClB,eAAe;;IAEf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yDAA8D;AAClE;;AAEA,2BAA2B;AAC3B;IACI;QACI,YAAY;QACZ,QAAQ;IACZ;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,8BAA8B;AAC9B;IACI;QACI,YAAY;QACZ,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,WAAW,uBAAuB,EAAE;IACpC,MAAM,yBAAyB,EAAE;IACjC,MAAM,wBAAwB,EAAE;IAChC,MAAM,yBAAyB,EAAE;IACjC,MAAM,wBAAwB,EAAE;AACpC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,qBAAqB;IACzB;AACJ","sourcesContent":[".endgame_buttons {\n    position: absolute;\n    bottom: clamp(24px, 5vh, 36px);\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    width: min(280px, 90vw);\n}\n\n.endgame_button {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    font-family: 'Kim';\n    text-transform: uppercase;\n    transition: all 0.2s ease;\n    position: relative;\n    border-radius: 4px;\n}\n\n.endgame_button_primary {\n    height: clamp(44px, 8vh, 56px);\n    font-size: clamp(16px, 3vw, 20px);\n    background: linear-gradient(180deg, #ffd700 0%, #ffa600 100%);\n    color: #1c1f25;\n    border: 2px solid #ffd700;\n    box-shadow: \n        0 0 20px rgba(255, 166, 0, 0.3),\n        inset 0 0 10px rgba(255, 255, 255, 0.5);\n    text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);\n}\n\n.endgame_button_primary:hover {\n    transform: translateY(-2px);\n    box-shadow: \n        0 0 30px rgba(255, 166, 0, 0.5),\n        inset 0 0 15px rgba(255, 255, 255, 0.7);\n}\n\n.endgame_button_primary:active {\n    transform: translateY(1px);\n    background: linear-gradient(180deg, #ffa600 0%, #ffd700 100%);\n}\n\n.endgame_button_secondary {\n    height: clamp(36px, 7vh, 48px);\n    width: 90%;\n    font-size: clamp(14px, 2.5vw, 16px);\n    background: linear-gradient(to bottom, #2a3746 0%, #1c1f25 100%);\n    color: #ffffff;\n    border: 1px solid #3c616c;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.endgame_button_secondary:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 3px;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 0%, transparent 100%);\n    opacity: 0;\n    transition: opacity 0.2s ease;\n}\n\n.endgame_button_secondary:hover {\n    border-color: #51fdff;\n    box-shadow: 0 0 10px rgba(81, 253, 255, 0.3);\n}\n\n.endgame_button_secondary:active {\n    transform: scale(0.98);\n    background: linear-gradient(to bottom, #1c1f25 0%, #2a3746 100%);\n}\n\n.defeat_title {\n    background-size: 100% 100%;\n    height: clamp(24px, 5vh, 54px);\n    width: min(800px, 90%);\n    margin: clamp(16px, 5vh, 50px) auto clamp(12px, 3vh, 30px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n.defeat_title .defeat_title_bg {\n    height: clamp(48px, 8vh, 96px);\n    width: auto;\n    max-width: 100%;\n    object-fit: contain;\n    animation: titleBounce 1s cubic-bezier(0.36, 0, 0.66, 1.5) forwards;\n    transform-origin: center;\n}\n\n.defeat_title .defeat_title_effect {\n    position: absolute;\n    top: clamp(-32px, -6vh, -72px);\n    right: 1vw;\n    width: 30vh;\n    animation: bounce 0.8s ease alternate;\n    -webkit-animation: bounce 0.8s ease alternate;\n    transform-origin: center;\n}\n\n@media screen and (max-width: 480px) {\n    .defeat_title {\n        width: 95%;\n        height: clamp(20px, 4vh, 24px);\n        margin: clamp(12px, 3vh, 16px) auto clamp(8px, 2vh, 12px);\n    }\n    \n    .defeat_title .defeat_title_bg {\n        height: clamp(36px, 6vh, 48px);\n    }\n    \n    .defeat_title .defeat_title_effect {\n        width: 50vh;\n        top: clamp(-24px, -4vh, -28px);\n    }\n\n    @keyframes bounce {\n        50% {\n            transform: scale(1.15);\n        }\n    }\n\n    @-webkit-keyframes bounce {\n        50% {\n            transform: scale(1.15);\n        }\n    }\n}\n\n@keyframes titleBounce {\n    0% { \n        transform: scale(0.5); \n        opacity: 0;\n    }\n    50% { \n        transform: scale(1.2);\n        opacity: 1;\n    }\n    75% { \n        transform: scale(0.9);\n    }\n    100% { \n        transform: scale(1);\n    }\n}\n\n.endgame_rewards_container {\n    background-image: url(\"@assets/game_end/rewards_bg.png\");\n    background-size: 100% 100%;\n    background-position: -18px;\n    width: 100%;\n    height: 156px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    bottom: 30vh;\n    z-index: 0;\n}\n\n/* Update media query for small screens */\n@media screen and (max-width: 480px), \n       screen and (max-height: 600px) {\n    .endgame_rewards_container {\n        transform: scale(0.8);\n        bottom: 25vh;\n    }\n    \n    .endgame_rewards_items {\n        gap: 8px;\n        max-width: 90%;\n    }\n    \n    .streak_gold_list {\n        width: 56px;\n        height: 56px;\n    }\n    \n    .streak_gold_list > div:first-child {\n        width: 36px;\n        height: 36px;\n    }\n    \n    .streak_gold_list_amount {\n        font-size: 12px;\n    }\n}\n\n.endgame_rewards_items {\n    position: absolute;\n    bottom: 18px;\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    max-width: 80%;\n    padding: 0 20px;\n}\n\n.streak_gold_list {\n    width: 68px;\n    height: 68px;\n    background-color: #1c1f25;\n    border: 1px solid #147fa6;\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    z-index: 10;\n    position: relative;\n    transition: transform 0.2s ease;\n}\n\n.streak_gold_list:hover {\n    transform: scale(1.05);\n    border-color: #51fdff;\n    box-shadow: 0 0 10px rgba(81, 253, 255, 0.3);\n}\n\n.streak_gold_list > div:first-child {\n    width: 42px;\n    height: 42px;\n    background-repeat: no-repeat;\n}\n\n.streak_gold_list img {\n    width: 64px;\n    height: 58px;\n    margin-left: 6px;\n}\n\n.streak_gold_list_amount {\n    position: absolute;\n    bottom: 6px;\n    right: 8px;\n    font-size: 14px;\n    font-weight: bold;\n    color: white;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.endgame_rewards_heading_container {\n    position: absolute;\n    top: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.endgame_rewards_heading {\n    font-size: 16px;\n    font-weight: 600;\n    color: #ffffff;\n    text-transform: uppercase;\n}\n\n.victory_title_effect {\n    position: absolute;\n    top: -46px;\n    left: calc(50% + 234px);\n    font-size: 172px;\n    font-weight: bolder;\n    color: #ffffff;\n    text-shadow: #afafaf 0px 4px;\n  }\n\n  .game_leave_dialog {\n    background-image: url(\"@assets/leaderboard/recap_bg.png\");\n    background-size: 100% 100%;\n    width: 350px;\n    height: 140px;\n    padding: 15px;\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    color: #ffffff;\n  }\n  \n  .game_leave_btn {\n    background-image: url(\"@assets/HUD/button_bg_idle.png\");\n    background-size: 100% 100%;\n    width: 50%;\n    height: 52px;\n  \n    display: flex;\n    align-items: center;\n    justify-content: center;\n  \n    color: #ffffff;\n  }\n  \n  .game_leave_btn:hover {\n    background-image: url(\"@assets/HUD/button_bg_active.png\");\n  }\n\n.endgame_meet_team_msg {\n    font-size: 32px;\n    font-weight: 600;\n    color: #ffffff;\n    text-align: center;\n}\n\n.endgame_leave {\n    background-image: url(\"@assets/HUD/skip_btn_bg.png\");\n    background-size: 100% 100%;\n    width: 156px;\n    height: 56px;\n  \n    font-size: 16px;\n    font-weight: 600;\n    color: #ffffff;\n  \n    display: flex;\n    justify-content: center;\n    align-items: center;\n  \n    padding-right: 8px;\n    cursor: pointer;\n  \n    position: absolute;\n    bottom: 36px;\n}\n  \n.endgame_leave:hover {\n    background-image: url(\"@assets/game_end/leave_btn_active.png\");\n}\n\n/* For very small screens */\n@media screen and (max-width: 360px) {\n    .endgame_buttons {\n        bottom: 16px;\n        gap: 6px;\n    }\n\n    .endgame_button_primary {\n        height: 40px;\n    }\n\n    .endgame_button_secondary {\n        height: 32px;\n    }\n}\n\n/* For landscape orientation */\n@media screen and (max-height: 600px) and (orientation: landscape) {\n    .endgame_buttons {\n        bottom: 16px;\n        gap: 8px;\n    }\n\n    .endgame_button_primary {\n        height: 44px;\n        font-size: 16px;\n    }\n\n    .endgame_button_secondary {\n        height: 36px;\n        font-size: 14px;\n    }\n}\n\n.endgame_unlock_message {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    background: rgba(255, 255, 255, 0.1);\n    padding: 12px 24px;\n    border-radius: 8px;\n    color: #fff;\n    font-size: 16px;\n}\n\n.shaking-lock {\n    width: 24px;\n    height: 24px;\n    animation: shake 2.5s ease-in-out infinite;\n}\n\n@keyframes shake {\n    0%, 100% { transform: rotate(0deg); }\n    20% { transform: rotate(-10deg); }\n    40% { transform: rotate(10deg); }\n    60% { transform: rotate(-10deg); }\n    80% { transform: rotate(10deg); }\n}\n\n.endgame_characters_grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 25px;\n    justify-content: center;\n    align-items: center;\n    margin-top: 3vh;\n    min-height: 20vh;\n    padding: 0 20px;\n}\n\n@media (max-width: 768px) {\n    .endgame_characters_grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 15px;\n    }\n}\n\n@media (max-width: 480px) {\n    .endgame_characters_grid {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 10px;\n    }\n}\n\n@media (max-height: 600px) {\n    .endgame_characters_grid {\n        margin-top: -1vh;\n        transform: scale(0.8);\n    }\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
